import React, { createRef, useState, useEffect } from "react";
import Canvas from "../../../components/vectors/canvas";
import MathJax from "../../../components/react-mathjax-preview";
import VectorParser from "../../../lib/vector-math-parser";
import "../../../css/VectorStyles.scss";
import TextEditor from "../../../components/TextEditor";

const VectorQuestion = ({
  answers,
  answerType,
  variableMap,
  currentQuestionID,
  vectorSettings,
  questionText,
  vectorBelowQuestionText,
  onQuestionVectors,
  addSingleQuestionAnswerState,
  freeFormVectorOptions
}) => {
  const canvasRef = createRef();
  const [vector, setVector] = useState([]);

  useEffect(() => {
    if (variableMap !== undefined){
      let vectorsQ = variableMap.getVectorsArray(vectorSettings.enableIdenticalVector, vectorSettings);
      if (answers && answerType !== 2) {
        const gridwidth = parseInt((vectorSettings.width / vectorSettings.stepSize),10);
        const gridheight = parseInt((vectorSettings.height / vectorSettings.stepSize),10);
        let newAnswerlistArr = onGenerateAnswerVector(answers)
        let shouldRandomize = false;
        let firstAttempt = true;
        let i=0;
        do{
          if(firstAttempt){
            shouldRandomize = VectorParser.shouldRandomize(newAnswerlistArr, gridwidth, gridheight);
          }
          if(shouldRandomize){
            console.log("answer vectors is same so randomizing now..")
            vectorsQ = variableMap.getVectorsArray(vectorSettings.enableIdenticalVector, vectorSettings);
            setVector(vectorsQ);
          }
          newAnswerlistArr = onGenerateAnswerVector(answers);
          shouldRandomize = VectorParser.shouldRandomize(newAnswerlistArr, gridwidth, gridheight);
          firstAttempt=false;
          i++;
          if(i>10){
            break;
          }
        }while(shouldRandomize);
      }
      setVector(vectorsQ);
    } 
      
  }, [variableMap, answers]);

  useEffect(() => {
    if (canvasRef && canvasRef.current && vector) {
      canvasRef.current.drawVectors({ vectors: vector });
    }
  }, [vector, canvasRef]);

  useEffect(() => {
    if (vector && vector.length) {
      let vectorVariableMapStr = variableMap.toString();
      console.debug("vectorVariableMapStr", vectorVariableMapStr);
      if (addSingleQuestionAnswerState) {
        addSingleQuestionAnswerState({
          vector_variable_map_string: vectorVariableMapStr,
        });
      }
    }
  }, [vector]);

  const onGenerateAnswerVector = (answerArrList) => {
    let newAnswerlistArr = answerArrList.map((answerlist) => {
      if(answerlist && answerlist.vectorAnswerFormula){
        let vectorAns = VectorParser.generateAnswerVector(
          answerlist.vectorAnswerFormula,
          variableMap,
          vectorSettings
        );
        return vectorAns;
      }
      return null;
    })

    return newAnswerlistArr;

  }

  console.log(`Point 0 ::: Before Rendering Grid Settings Data => `, vectorSettings);
  
  return (
    <div className="vector-question-container w-100">
      <div className="vector-question-text-container">
        <MathJax math={TextEditor.replaceVectorVars(questionText, variableMap)} />
      </div>
      <div className="vector-question-canvas-container w-100">
        <Canvas
          ref={canvasRef}
          degStepSize={5}
          magStepSize={1}
          stepDeg={false}
          readOnly={true}
          isAnswer={false}
          height={vectorSettings.height}
          width={vectorSettings.width}
          stepSize={vectorSettings.stepSize}
          enableGrid={vectorSettings.enableGrid}
          enableBorder={vectorSettings.enableBorder}
          enableRuler={vectorSettings.enableRuler}
          rulerXPoint={vectorSettings.rulerXPoint}
          rulerYPoint={vectorSettings.rulerYPoint}
          enableDarkGridLine={vectorSettings.enableDarkGridLine}
          freeBodyDiagram={vectorSettings.image}
          fbdWidth={vectorSettings.stepSize * vectorSettings.imageWidthUnit}
          fbdHeight={vectorSettings.stepSize * vectorSettings.imageHeightUnit}
          fbdX={vectorSettings.imageX}
          fbdY={vectorSettings.imageY}
          gridColor={vectorSettings.gridColor}
          rulerXLabel={vectorSettings.rulerXLabel}
          rulerYLabel={vectorSettings.rulerYLabel}
          rulerNXLabel={vectorSettings.rulerNXLabel}
          rulerNYLabel={vectorSettings.rulerNYLabel}
          commonVectorSettings={vectorSettings}
          showScale={vectorSettings.showScale}
          scale={vectorSettings.scale}

          questionShowComponents={freeFormVectorOptions.question_show_components}
          questionShowMagnitudeAngle={freeFormVectorOptions.question_show_magnitude_angle}
          currentQuestionID={currentQuestionID}
          
        ></Canvas>
      </div>
      {vectorBelowQuestionText !== '' && <div className="vector-question-text-container" style={{textAlign:'left'}}>
        <MathJax math={vectorBelowQuestionText} />
      </div>}
    </div>
  );
};

export default VectorQuestion;
